__turbopack_context__.v({
  "className": "mona_sans_a5f6ef90-module__LVdGEG__className",
});
